module.exports = {
	sanity: {
		projectId: process.env.GATSBY_SANITY_PROJECT_ID ?? '0dljr336',
		dataset: process.env.GATSBY_SANITY_DATASET ?? 'staging',
		// Set this value if you want a gql tagged endpoint
		// graphqlTag: 'toc-content',
	},
};
